var exports = {
  "P": "ProfileCardLayout.module__previewLabel___aEZScj",
  "K": "ProfileCardLayout.module__profileCard___aEZScj",
};

module.exports = exports;
